import FEATURE_FLAG_NAMES from 'platform/utilities/feature-toggles/featureFlagNames';

// True when the CAVE (IDP) document-processing feature toggle is enabled.
// Single source of truth for the flag key + default so consumers don't
// duplicate the featureToggles lookup.
export const selectCaveEnabled = state =>
  state.featureToggles?.[FEATURE_FLAG_NAMES.survivorsBenefitsIdp] ?? false;
